import RibbonText from 'modules/content-cms/components/ribbon-text';
import renderDocument from 'modules/content-cms/util/render-document';
import React from 'react';
import { ISectionIngredientsFields } from '../../../../global';
import ContentContainer from '../components/content-container';
import Image from '../components/image';
import Title from '../components/title';

const renderIngredientIcon = (icon: string) => {
  switch (icon) {
    case 'pferd':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-12 w-auto"
          viewBox="0 0 28.12 27.64"
        >
          <g>
            <g>
              <path
                stroke="currentColor"
                strokeWidth={1}
                fill="none"
                d="M19.28,14.09a8.71,8.71,0,0,0,3.37,6.71v5.86a.48.48,0,0,0,.48.48h1a.48.48,0,0,0,.49-.48V14.72a5,5,0,0,0-5-5H13.78c-4.93-.35-6.29-6-6.29-6a3.65,3.65,0,0,0-2.93-2.4,8.29,8.29,0,0,0-1.29-.13H2.81S.29-.39,1.18,1.21c.22.39.25.4.28.6L1.18,5,.52,8.87c-.15.74.58.83,1,.91,0,0,2,.73,2.34-1.72.3-1.5,1.45-1.45,1.45-1.45s-.39,7.53,3.45,11.33v8.69a.48.48,0,0,0,.48.48h1a.48.48,0,0,0,.48-.48V17.94h9.51m7.35,2.17c-.52-.1-.82-1.1-.82-1.57V14.46c0-.9-1.64-.9-2.46-1.72"
              />
            </g>
          </g>
        </svg>
      );
    case 'karotte':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-12 w-auto"
          viewBox="0 0 12.34 31.88"
        >
          <defs></defs>
          <g>
            <g>
              <path
                stroke="currentColor"
                fill="none"
                d="M6.17,9.07c-3.94,0-6.31.52-5.52,5.77S4.07,28,6.17,31.38"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M6.17,9.07c3.94,0,6.31.52,5.52,5.77S8.27,28,6.17,31.38"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M5.86,9C4,7.39,2,2.83,2.26.5,6.62,1.78,6.45,6.43,5.86,9Z"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M5.86,9c2.13.16,5.74-1.93,5.9-5C8.61,4.49,6.43,6.43,5.86,9Z"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M.65,14.84c2.15,1,2.64,1,3.79.81"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M10.2,20.75c-1.48,1.15-2.63.82-3.95.82"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M10.69,18.78a6.15,6.15,0,0,1-3.2.57"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M6.53,26.93A2.19,2.19,0,0,1,4.17,27"
              />
            </g>
          </g>
        </svg>
      );
    case 'rind':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-10 w-auto"
          viewBox="0 0 35.02 23.84"
        >
          <defs></defs>
          <g>
            <g>
              <path
                stroke="currentColor"
                fill="none"
                d="M23,10.18a6.74,6.74,0,0,0,6.74,6.74v5.92a.5.5,0,0,0,.5.5h1.1a.5.5,0,0,0,.5-.5V7.57a4,4,0,0,0-4-4H10.19a3.44,3.44,0,0,0-.65-.89c-1.3-1.31-3.13-1.07-4.48.17L.8,6.6s0,0-.05.05L.7,6.71A.84.84,0,0,0,.75,7.85l1,1a1,1,0,0,0,.78.34l.33,0,4.58-1,5.17,7.75v6.93a.5.5,0,0,0,.51.5h1.09a.5.5,0,0,0,.51-.5V15.91H26.16"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M5.21.5H6.76A1.38,1.38,0,0,1,8.14,1.88v.75"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M34.52,11.93a1,1,0,0,1-1-1V6.34A1.52,1.52,0,0,0,32,4.82H30.7"
              />
            </g>
          </g>
        </svg>
      );
    case 'huhn':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 23.68 29"
        >
          <defs></defs>
          <g>
            <g>
              <path
                stroke="currentColor"
                fill="none"
                d="M8.14,3.57A1.28,1.28,0,1,0,8.14,1a1.24,1.24,0,0,0-1,.44A1.27,1.27,0,0,0,6,.5a1.25,1.25,0,0,0-1.21,1,1.28,1.28,0,1,0-1,2.12"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M21.84,8.32c0,.07,0,.14,0,.21,0,2.23-2.91,4-6.5,4s-6.5-1.81-6.5-4V5.76h0a2.9,2.9,0,0,0-5.8,0v7.75h0a10.06,10.06,0,0,0,7.57,9.57,2.58,2.58,0,0,0,5,0A10,10,0,0,0,21.84,8.32Z"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M7.22,13.39c-.86,1.4-.69,3.45,1.48,5.32l.29.23H9A9.41,9.41,0,0,0,10.83,20h0c1.92.86,4.19,1.18,5.61.37A5.9,5.9,0,0,0,15.83,16h0"
              />
              <line
                x1="12.96"
                y1="24.99"
                x2="12.96"
                y2="28.5"
                fill="currentColor"
                stroke="currentColor"
              />
              <line
                x1="13.86"
                y1="28.5"
                x2="10.87"
                y2="28.5"
                fill="currentColor"
                stroke="currentColor"
              />
              <polygon
                points="0.5 7.47 3.04 9.09 3.04 7.47 3.04 5.85 0.5 7.47"
                fill="currentColor"
                stroke="currentColor"
              />
            </g>
          </g>
        </svg>
      );
    case 'buchweizen':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-16 w-auto"
          viewBox="0 0 440 440"
        >
          <g fill="none" fillRule="nonzero">
            <path
              fill="currentColor"
              d="M247.3 271.8l7.9-37c1-4.7 1.8-9.5 2.4-14.7l2.2-18 9 15.7c.8 1.3 1.9 2.7 3 4.2l4 5.1-3.4 3.7c-2.4 2.7-4.5 5.4-6.1 8.2l-19 32.8z"
            />
            <path d="M113.9 189.1c17.9.9 31.7 4.5 42.6 9.8 8-15.3 18.4-29.5 29.6-40.4-3.3-3.8-6.9-7.6-11-11.5-41.5-38.6-94.3-52.8-115.8-29.6-14.5 15.6-8.1 46.8 8.3 75.5 14.1-3.2 29.9-4.6 46.3-3.8z" />
            <path
              fill="currentColor"
              d="M159 206.8l-5.3-2.6c-10.9-5.3-24.4-8.4-40.2-9.2-15.3-.7-30.4.5-44.8 3.6l-4.3.9-2.2-3.8c-15.5-27.1-25.6-63-7.5-82.5 23.7-25.5 79.5-12.3 124.3 29.3 4 3.7 7.7 7.6 11.5 11.9l3.7 4.3-4.1 4c-10.7 10.3-20.8 24.1-28.5 38.8l-2.6 5.3zm-44.9-23.7c15.3.7 28.3 3.4 39.7 8.1 6.8-12.1 15.2-23.5 24-32.8-2.2-2.4-4.5-4.7-6.9-6.9-19.2-17.8-42.1-31.1-62.8-36.5-19.9-5.2-35.7-2.8-44.5 6.6-10.8 11.6-8 36.7 7 64.6 14.1-2.8 28.7-3.9 43.5-3.1z"
            />
            <path
              fill="none"
              d="M263.6 220.8c1.2 2.1 2.8 4 4.3 6 10-11 25.4-20 47.6-25.5 19.8-4.8 42.2-5.5 62-2.4 26.7-42.6 31.8-89.1 8.6-106.3-25.4-18.8-79.8 11.8-108.4 50.3-7.8 10.5-13.2 20.5-16.5 29.9 3.8 13.8 4.6 30.3 2.4 48z"
            />
            <path
              fill="currentColor"
              d="M267.6 236.1l-5.2-6.6a35.9 35.9 0 0 1-4-5.7l-1-1.7.2-2c2.1-16.9 1.3-32.7-2.1-45.6l-.5-1.8.6-1.8c3.6-10.3 9.5-20.9 17.3-31.5 14.6-19.7 36.1-37.8 57.6-48.5 24.5-12.2 45.5-13.3 59.2-3.1 12.8 9.5 18.8 26.9 16.8 48.9-1.8 20.5-10.3 43.7-23.9 65.3l-2.1 3.4-3.9-.6c-19.5-3-41.2-2.2-59.7 2.3-19.7 4.8-34.7 12.7-44.6 23.7l-4.7 5.3zm0-62.8c3.1 12.6 4 27.4 2.5 43.1 11.1-9.4 25.9-16.4 44-20.9 18.7-4.5 40.5-5.6 60.4-3.1 23.6-39.5 27.3-80.8 8.1-94.9-9.8-7.2-26.8-5.7-46.8 4.2-19.8 9.8-39.7 26.6-53.3 44.9-6.6 9.1-11.6 18-14.9 26.7z"
            />
            <path
              fill="none"
              d="M147.2 220.1c2.4-7.2 5.6-14.3 9.2-21.3-10.9-5.3-24.6-8.9-42.6-9.8-16.4-.8-32.1.6-46.3 3.8-34.9 7.7-60.2 25.8-61.3 48.2-1.5 31.5 54.2 59.8 102.1 62.1 19.2.9 34.7-1.9 46.7-7.3-14.6-15.4-19.7-40.8-7.8-75.7z"
            />
            <path
              fill="currentColor"
              d="M115.5 309.4c-2.4 0-4.9-.1-7.4-.2-24.5-1.2-51.5-9-72.3-20.9C12.1 274.7-.5 257.8.3 240.8c1.2-24.5 26.5-45.1 66-53.8 15.4-3.4 31.5-4.7 47.9-3.9 17.7.9 32.4 4.3 44.9 10.4l5.5 2.7-2.8 5.5c-3.7 7.1-6.7 13.9-8.9 20.4-10.3 30.1-8 54.2 6.5 69.7l5.7 6.1-7.6 3.5c-11.7 5.3-25.8 8-42 8zm-10.6-114.6c-12.3 0-24.5 1.3-36.1 3.9-33.5 7.4-55.7 24.1-56.6 42.6-.6 12.1 10.2 25.4 29.5 36.5 19.2 11 44.2 18.2 66.9 19.3 14 .7 26.2-.7 36.6-4-12.6-18.5-14-44.8-3.7-75 1.8-5.3 4.1-10.8 6.7-16.4-9.8-3.9-21.5-6.1-34.7-6.8-2.8 0-5.7-.1-8.6-.1z"
            />
            <g>
              <path
                fill="none"
                d="M431.1 232c-4.3-17.7-26.5-28.9-53.5-33.1-19.8-3.1-42.3-2.4-62 2.4-22.3 5.4-37.7 14.5-47.6 25.5-2.7 3-5 6-6.9 9.3-1.5 6.9-3.4 13.9-5.8 20.9-.3.9-.7 1.7-1 2.6-.1 5 .2 10 1.4 15.1 7.5 30.7 33.6 50.6 86.8 37.7 55.1-13.4 96.1-49.7 88.6-80.4z"
              />
              <path
                fill="currentColor"
                d="M312.5 322.3c-33 0-55.2-16-62.6-46.2a67.2 67.2 0 0 1-1.6-16.7v-1l.3-.9c.2-.4.3-.9.5-1.3s.3-.8.5-1.2c2.2-6.5 4.1-13.3 5.6-20.2l.2-.9.5-.8c2.1-3.6 4.6-7 7.6-10.3 11.6-12.7 28.6-21.9 50.7-27.3 19.9-4.9 43.4-5.8 64.4-2.5 32.5 5.1 53.8 18.8 58.4 37.6 8.2 33.8-33.5 73.1-92.9 87.6-11.4 2.8-22 4.1-31.6 4.1zm-52.1-61.6c-.1 4.7.3 8.8 1.2 12.6 3.6 14.7 11.4 25.3 23.1 31.3 13.8 7.1 32.8 7.7 56.4 2 25.4-6.2 49.2-18 65.1-32.3 15.3-13.8 22.1-28.3 19-40.8-3.3-13.7-21.5-24.4-48.6-28.6-19.5-3-41.2-2.2-59.7 2.3-19.7 4.8-34.7 12.7-44.6 23.7-2.2 2.4-4.1 4.9-5.6 7.5-1.5 7-3.5 13.9-5.7 20.6-.2.6-.4 1.2-.6 1.7 0-.1 0 0 0 0z"
              />
            </g>
            <g>
              <path
                fill="none"
                d="M261.1 236.1c1.1-5.1 1.9-10.2 2.5-15.2 2.2-17.7 1.4-34.3-2.3-47.9-4.6-17-13.4-29.5-26.2-33.8-14.8-5.1-32.8 3.7-49 19.3-11.3 10.9-21.7 25.1-29.6 40.4-3.6 7-6.8 14.1-9.2 21.3-11.9 34.9-6.7 60.2 7.8 75.7 5.9 6.3 13.3 11.2 21.9 14.1 29.3 10 59.6-.9 77.4-50.4.3-.9.7-1.7 1-2.6 2.3-7 4.2-14 5.7-20.9z"
              />
              <path
                fill="currentColor"
                d="M196.3 319.4c-6.8 0-14-1.2-21.3-3.7-9.4-3.2-17.6-8.5-24.4-15.7-17.5-18.6-20.7-47.7-9.1-81.8 2.4-7.1 5.6-14.5 9.6-22.1 8.3-15.9 19.2-30.8 30.8-41.9 19.5-18.8 39.1-26.2 55.1-20.7 14.1 4.8 24.8 18.3 30.1 38 3.9 14.4 4.7 31.8 2.5 50.2-.7 5.6-1.5 10.7-2.6 15.8-1.6 7.3-3.6 14.6-5.9 21.6-.2.6-.4 1.2-.6 1.7-.1.3-.3.6-.4 1-13.6 37.5-36.2 57.6-63.8 57.6zm30-175.7c-10.4 0-23.2 6.7-36.1 19.1-10.7 10.3-20.8 24.1-28.5 38.8-3.7 7.1-6.7 13.9-8.9 20.4-10.3 30.1-8 54.2 6.5 69.7 5.4 5.8 12 10 19.5 12.6 14.1 4.8 26.9 4 38.1-2.4 13.2-7.5 23.8-22.4 31.7-44.4.2-.4.3-.9.5-1.3s.3-.8.5-1.2c2.2-6.5 4.1-13.3 5.6-20.2 1-4.7 1.8-9.5 2.4-14.7 2.1-16.9 1.3-32.7-2.1-45.6-4.2-15.7-12.1-26.2-22.4-29.7-2.1-.7-4.4-1.1-6.8-1.1z"
              />
            </g>
          </g>
        </svg>
      );
    case 'quinoa':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-12 w-auto"
          viewBox="0 0 440 440"
        >
          <g fill="none" fillRule="nonzero">
            <g transform="translate(117 153)">
              <circle cx="71.7" cy="71.9" r="67.76" fill="#FFF" />
              <path
                fill="#3D4545"
                d="M71.7 143.5A71.77 71.77 0 0 1 0 71.8 71.77 71.77 0 0 1 71.7.1a71.77 71.77 0 0 1 71.7 71.7c-.09 39.55-32.24 71.7-71.7 71.7zm0-135.41A63.86 63.86 0 0 0 7.9 71.9a63.86 63.86 0 0 0 63.81 63.82 63.86 63.86 0 0 0 63.82-63.82C135.42 36.7 106.82 8.1 71.7 8.1z"
              />
            </g>
            <g transform="translate(0 261)">
              <ellipse cx="72.1" cy="72.6" fill="#FFF" rx="67.76" ry="67.77" />
              <path
                fill="#3D4545"
                d="M72.1 144.31A71.77 71.77 0 0 1 .4 72.6 71.77 71.77 0 0 1 72.1.89a71.77 71.77 0 0 1 71.7 71.7 71.77 71.77 0 0 1-71.7 71.72zm0-135.53A63.86 63.86 0 0 0 8.28 72.6a63.86 63.86 0 0 0 63.82 63.82A63.86 63.86 0 0 0 135.9 72.6 63.86 63.86 0 0 0 72.1 8.78z"
              />
            </g>
            <g transform="translate(13 39)">
              <ellipse cx="62.61" cy="63" fill="#FFF" rx="58.45" ry="58.44" />
              <path
                fill="#3D4545"
                d="M62.61 125.4A62.46 62.46 0 0 1 .2 63 62.46 62.46 0 0 1 62.6.6 62.46 62.46 0 0 1 125.03 63a62.46 62.46 0 0 1-62.42 62.4zm0-116.77A54.5 54.5 0 0 0 8.14 63.1a54.5 54.5 0 0 0 54.47 54.47A54.5 54.5 0 0 0 117.1 63.1 54.5 54.5 0 0 0 62.61 8.63z"
              />
            </g>
            <g transform="translate(123 34)">
              <circle cx="52.7" cy="52.79" r="48.18" fill="#FFF" />
              <path
                fill="#3D4545"
                d="M52.7 104.9A52.14 52.14 0 0 1 .59 52.8 52.14 52.14 0 0 1 52.69.68a52.14 52.14 0 0 1 52.11 52.1 52.2 52.2 0 0 1-52.1 52.11zm0-96.26A44.33 44.33 0 0 0 8.44 52.89 44.33 44.33 0 0 0 52.7 97.15a44.27 44.27 0 0 0 44.25-44.26C96.85 28.46 77.03 8.64 52.7 8.64z"
              />
            </g>
            <g transform="translate(13 162)">
              <circle cx="52.01" cy="52.79" r="48.18" fill="#FFF" />
              <path
                fill="#3D4545"
                d="M52 104.8a52.1 52.1 0 0 1-52-52A52.2 52.2 0 0 1 52.1.68a52.14 52.14 0 0 1 52.11 52.1c0 28.76-23.45 52.01-52.2 52.01zm0-96.26A44.33 44.33 0 0 0 7.76 52.79a44.33 44.33 0 0 0 44.26 44.26A44.33 44.33 0 0 0 96.27 52.8 44.27 44.27 0 0 0 52 8.54z"
              />
            </g>
            <g transform="translate(322 138)">
              <ellipse cx="59" cy="60.1" fill="#FFF" rx="55.07" ry="55.54" />
              <path
                fill="#3D4545"
                d="M59 119.6c-32.55 0-59-26.67-59-59.5S26.45.6 59 .6s59 26.67 59 59.5-26.45 59.5-59 59.5zM59 8.53c-28.22 0-51.13 23.1-51.13 51.57 0 28.46 22.9 51.57 51.13 51.57 28.22 0 51.13-23.1 51.13-51.57 0-28.36-22.9-51.57-51.13-51.57z"
              />
            </g>
            <g transform="translate(290 224)">
              <ellipse cx="59" cy="59.6" fill="#FFF" rx="55.07" ry="55.54" />
              <path
                fill="#3D4545"
                d="M59 119.1c-32.55 0-59-26.67-59-59.5C0 26.78 26.45.1 59 .1s59 26.68 59 59.5c0 32.83-26.45 59.5-59 59.5zM59 8.14C30.78 8.13 7.87 31.24 7.87 59.7c0 28.47 22.9 51.57 51.13 51.57 28.22 0 51.13-23.1 51.13-51.57 0-28.46-22.9-51.57-51.13-51.57z"
              />
            </g>
            <g transform="translate(69 105)">
              <ellipse cx="59.89" cy="60.2" fill="#FFF" rx="55.07" ry="55.54" />
              <path
                fill="#3D4545"
                d="M59.9 119.7C27.33 119.7.88 93.02.88 60.2.89 27.37 27.34.7 59.89.7c32.56 0 59.01 26.67 59.01 59.5 0 32.82-26.45 59.5-59 59.5zm0-110.97c-28.23 0-51.15 23.1-51.15 51.57 0 28.46 22.92 51.57 51.14 51.57 28.23 0 51.14-23.11 51.14-51.57 0-28.47-22.91-51.57-51.14-51.57z"
              />
            </g>
            <g transform="translate(87 237)">
              <ellipse cx="59.89" cy="60.5" fill="#FFF" rx="55.07" ry="55.54" />
              <path
                fill="#3D4545"
                d="M59.9 119.9C27.33 119.9.88 93.22.88 60.4.89 27.57 27.34.9 59.89.9c32.56 0 59.01 26.67 59.01 59.5 0 32.82-26.45 59.5-59 59.5zm0-110.97c-28.23 0-51.15 23.1-51.15 51.57 0 28.46 22.92 51.57 51.14 51.57 28.23 0 51.14-23.11 51.14-51.57 0-28.47-22.91-51.57-51.14-51.57z"
              />
            </g>
            <g transform="translate(138 284)">
              <ellipse cx="59" cy="60.1" fill="#FFF" rx="55.07" ry="55.54" />
              <path
                fill="#3D4545"
                d="M59 119.5C26.45 119.5 0 92.83 0 60S26.45.5 59 .5s59 26.67 59 59.5-26.45 59.5-59 59.5zM59 8.53c-28.22 0-51.13 23.1-51.13 51.57 0 28.46 22.9 51.57 51.13 51.57 28.22 0 51.13-23.1 51.13-51.57 0-28.46-22.9-51.57-51.13-51.57z"
              />
            </g>
          </g>
        </svg>
      );
    case 'lachs':
    case 'fisch':
    case 'forelle':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-auto"
          viewBox="0 0 32.18 10.42"
        >
          <defs></defs>
          <g>
            <g>
              <path
                stroke="currentColor"
                fill="none"
                d="M30.27,4.55a4.55,4.55,0,0,0,1.41-3A4.6,4.6,0,0,0,27,5.5,4.85,4.85,0,0,0,30.27,4.55Z"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M30.27,6.47a4.55,4.55,0,0,1,1.41,3A4.6,4.6,0,0,1,27,5.52,4.85,4.85,0,0,1,30.27,6.47Z"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M16.37,2.41A8,8,0,0,0,16.42.52a4.89,4.89,0,0,0-3.89,1.35,3.49,3.49,0,0,0-.32.35"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M9.45,9.75a3.7,3.7,0,0,0,3-.43,3.58,3.58,0,0,0-2-2.21,3.56,3.56,0,0,0-3,.2A3.93,3.93,0,0,0,9.45,9.75Z"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M21.71,7.56a2.29,2.29,0,0,0,.75.48,3.64,3.64,0,0,0,3-.43,4,4,0,0,0-.58-1.11"
              />
              <path
                stroke="currentColor"
                fill="none"
                d="M8,8.4C3.87,7.72.5,6.35.5,5.51c0-1.15,6.32-3.3,12.24-3.3a33.21,33.21,0,0,1,14.4,3.3h0a33.21,33.21,0,0,1-14.4,3.3h-.53"
              />
            </g>
          </g>
        </svg>
      );
    case 'kartoffel':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 28.2122 34.973"
        >
          <path
            fill="currentColor"
            stroke="none"
            d="M23.185,14.4164a.5305.5305,0,0,0,.62.861l1.157-.834a.53.53,0,1,0-.62-.86l-1.157.833Z"
          />
          <path
            d="M20.166,17.7244a.5305.5305,0,0,0,.62.861l1.157-.834a.5305.5305,0,0,0-.62-.861l-1.157.834Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M21.315,7.9524a.5277.5277,0,0,0-.22.43.5294.5294,0,0,0,.84.429l1.156-.833a.53.53,0,1,0-.619-.86l-1.157.834Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M17.915,8.3824a.5294.5294,0,0,0,.84.429l1.157-.833a.53.53,0,1,0-.62-.86l-1.157.834a.5277.5277,0,0,0-.22.43Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M15.088,8.7414a.53.53,0,1,0-.62-.86l-1.156.833a.53.53,0,1,0,.619.861l1.157-.834Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M15.852,4.4874a.53.53,0,1,0-.619-.86l-1.157.834a.5287.5287,0,0,0-.221.43.5364.5364,0,0,0,.1.309.53.53,0,0,0,.74.12l1.157-.833Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M19.25,13.8214a.5305.5305,0,0,0,.62.861l1.157-.834a.53.53,0,1,0-.62-.86l-1.157.833Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M17.757,25.4734a13.018,13.018,0,0,0,1.126-3.248c1.963,1.513,4.04,1.992,6.734-.051,4.084-3.098,2.946-11.376-.63-16.869A11.2166,11.2166,0,0,0,17.754.1594a9.061,9.061,0,0,0-6.941,1.492A6.9825,6.9825,0,0,0,7.557,6.98c-.007.113-.01.226-.01.34a7.835,7.835,0,0,0,.945,3.567,6.2436,6.2436,0,0,0-.999.398c-2.381,1.231-4.079,4.033-4.909,8.103a46.6542,46.6542,0,0,1-1.331,4.805A20.1608,20.1608,0,0,0,0,29.8214c0,1.987.858,3.63,3.527,4.731,4.738,1.955,11.302-3.216,14.23-9.079ZM8.615,7.0354a5.9809,5.9809,0,0,1,2.818-4.524A7.9986,7.9986,0,0,1,17.559,1.2a10.1746,10.1746,0,0,1,6.54,4.685,18.4735,18.4735,0,0,1,3.091,9.712c0,2.5-.727,4.605-2.214,5.732-2.314,1.755-3.959,1.362-5.909-.329a10.0954,10.0954,0,0,0-.531-4.371,9.0644,9.0644,0,0,0-4.799-5.231A7.9819,7.9819,0,0,0,9.58,10.65a6.8509,6.8509,0,0,1-.965-3.615ZM3.931,33.5714c-3.834-1.58-3.209-4.193-1.667-9.0581A47.9,47.9,0,0,0,3.622,19.6c.753-3.691,2.301-6.31,4.358-7.373a5.9792,5.9792,0,0,1,5.328.141,7.9975,7.9975,0,0,1,4.231,4.62A10.18,10.18,0,0,1,16.809,25c-3.063,6.133-9.081,10.138-12.878,8.571Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M10.562,29.8044a.531.531,0,0,0-.27-.699l-1.305-.576a.5319.5319,0,0,0-.7.27.5614.5614,0,0,0-.044.214.5291.5291,0,0,0,.316.485l1.304.577a.5321.5321,0,0,0,.699-.271Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M4.334,30.6924a.53.53,0,0,0,.271.699l1.304.575a.53.53,0,1,0,.429-.969L5.033,30.42a.53.53,0,0,0-.699.272Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M12.816,23.5234a.5313.5313,0,0,0-.27-.699l-1.305-.576a.53.53,0,0,0-.699.271.54.54,0,0,0-.045.213.5316.5316,0,0,0,.316.486l1.304.576a.5321.5321,0,0,0,.699-.271Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M13.755,22.4384l1.305.577a.5306.5306,0,0,0,.428-.9711l-1.305-.5759a.5324.5324,0,0,0-.699.271.54.54,0,0,0-.044.214.53.53,0,0,0,.315.485Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M7.931,19.2874a.5329.5329,0,0,0-.271-.7l-1.304-.576a.5329.5329,0,0,0-.7.271.5446.5446,0,0,0-.045.214.5316.5316,0,0,0,.316.486l1.305.576a.5321.5321,0,0,0,.699-.271Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M12.32,17.5874a.5323.5323,0,0,0-.271-.699l-1.305-.576a.5307.5307,0,0,0-.699.27.5446.5446,0,0,0-.045.214.53.53,0,0,0,.315.485l1.305.576a.5319.5319,0,0,0,.7-.27Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M15.454,16.3724a.5322.5322,0,0,0-.27-.699l-1.305-.576a.53.53,0,0,0-.699.271.5229.5229,0,0,0-.045.213.5306.5306,0,0,0,.315.486l1.305.576a.53.53,0,0,0,.699-.271Z"
            fill="currentColor"
            stroke="none"
          />
          <path
            d="M7.365,25.2744a.5324.5324,0,0,0-.27-.7l-1.305-.575a.53.53,0,0,0-.699.27.5446.5446,0,0,0-.045.214.5308.5308,0,0,0,.316.485l1.305.576a.5288.5288,0,0,0,.698-.27Z"
            fill="currentColor"
            stroke="none"
          />
        </svg>
      );
    case 'känguru':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-10 w-auto"
          viewBox="0 0 29.35 26.18"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M11.32,12A3.3,3.3,0,0,0,8,15.28V24L2.1,24a.86.86,0,0,0-.85.86v.61a.26.26,0,0,0,.25.26H9.92a.4.4,0,0,0,.4-.41v-4a1.21,1.21,0,0,1,1.21-1.21h2.15s.13,5.58,7.27,5.58h7.9c0-.78-1.65-1.4-3-1.4l-1.52,0a7.52,7.52,0,0,1-4.79-1.66"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M17.82,18.52a12.62,12.62,0,0,0-3.71-8.95"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M5.67,5.34c.87,4.56,5.23,1.2,8.44,4.23"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M17.82,18.52a5.75,5.75,0,0,0,1.68,4.07"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M12.56,12.22A3.19,3.19,0,0,0,11.32,12"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M8,17.84A7.77,7.77,0,0,0,5.56,14"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M6.24,13.34c-.15.45-.77.72-1.14,1-.58.4-.76.59-.71.91a.73.73,0,0,1-.62.83H3.66a.72.72,0,0,1-.72-.63c-.19-1.26,1.16-2.38,1.67-2.58A11.41,11.41,0,0,1,3.2,7.75a.31.31,0,0,0-.41-.3c-.64.21-1.74.38-2.06.06C-.09,6.7,1.47,3.81,2.29,3a1.87,1.87,0,0,1,1.87-.6A4.78,4.78,0,0,1,5,.89,1.2,1.2,0,0,1,6.73,2.51a4.8,4.8,0,0,1-1.24.84,2.06,2.06,0,0,1,.18,2"
              />
            </g>
          </g>
        </svg>
      );
    case 'lamm':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 24.54 22.79"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M6,1.24c.62-.45,1.8-1,2.18-.61s0,1-.28,1.64"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M7.85,2.27a1.36,1.36,0,0,1,.32.66S7.59,6.84,12.71,7.2h6.17A5.16,5.16,0,0,1,24,12.35v9.44a.5.5,0,0,1-.5.5H22.45a.51.51,0,0,1-.5-.5V16.65a6.22,6.22,0,0,1-2.4-4.79"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M21,15.7H9.57v6.05a.5.5,0,0,1-.5.5H8a.5.5,0,0,1-.5-.5V15.7A10.85,10.85,0,0,1,4.65,6.33L1.73,6l-.24,0A.74.74,0,0,1,1,5.56L.58,4.94a.61.61,0,0,1,.17-.8l0,0,0,0L3.52,1.41A3.3,3.3,0,0,1,6,1.24"
              />
            </g>
          </g>
        </svg>
      );
    case 'truthahn':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 29.35 26.59"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M8.76,18.34c-.27,1.49.57,3.2,3.06,4.08l.33.1h0a9.24,9.24,0,0,0,1.95.32h0c1.94.09,4-.39,5-1.56a5.43,5.43,0,0,0-2-3.61h0"
              />
              <line
                stroke="currentColor"
                x1="12.11"
                y1="22.6"
                x2="12.11"
                y2="26.09"
              />
              <line
                stroke="currentColor"
                x1="12.79"
                y1="26.09"
                x2="10.54"
                y2="26.09"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M18.75,20a6.5,6.5,0,0,0,2.31-4.82c0-4.13-4.38-7.48-9.78-7.48a13.15,13.15,0,0,0-2.46.25V3.69a3,3,0,0,0-5.9,0c.86,3-1.12,7.42-1.12,7.42C-2.58,19.64,5.87,22.6,11.28,22.6c.34,0,.68,0,1,0"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M20.1,18.36a3,3,0,0,0,.23.27c.94,1,2.06,1.49,2.83,1.06a1.13,1.13,0,0,0,.3-.24,2,2,0,0,0,.47-1.19,4,4,0,0,0,0-1,2.61,2.61,0,0,0,2.25,0,1,1,0,0,0,.31-.27,1.27,1.27,0,0,0,.2-.36,2.64,2.64,0,0,0-.48-2.21c1.14-.06,2-.5,2.23-1.24a1.87,1.87,0,0,0-.7-1.82,2,2,0,0,0,1.14-1.75c-.07-.65-.65-1.16-1.49-1.46a1.94,1.94,0,0,0,.29-1.93,2.24,2.24,0,0,0-2.45-.73,2.28,2.28,0,0,0-.28-2.57c-.61-.48-1.59-.33-2.57.29-.06-1.14-.5-2-1.24-2.24a1.9,1.9,0,0,0-1.82.71A2,2,0,0,0,17.52.51c-.64.07-1.15.65-1.46,1.49a1.88,1.88,0,0,0-1.93-.29,1.38,1.38,0,0,0-.3.24,2,2,0,0,0-.47,1.19,4,4,0,0,0,0,1,2.64,2.64,0,0,0-2.25,0,1,1,0,0,0-.31.27,1.27,1.27,0,0,0-.2.36,2.85,2.85,0,0,0,.67,2.48c.09.13.19.25.29.37"
              />
              <polyline
                stroke="currentColor"
                points="2.92 3.63 0.5 6.01 3.12 6.01"
              />
            </g>
          </g>
        </svg>
      );
    case 'ente':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 22.32 22.26"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M1.28,5.67a.79.79,0,0,1,0-1.57l2.87-.37V6Z"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M10.61,14.31a8.6,8.6,0,0,0,2.58,0,8.26,8.26,0,0,0,6.14-4.84A8.23,8.23,0,0,0,11.91,7a8,8,0,0,0-2.44.85"
              />
              <line
                stroke="currentColor"
                x1="12.07"
                y1="18.22"
                x2="12.07"
                y2="21.76"
              />
              <line
                stroke="currentColor"
                x1="12.98"
                y1="21.76"
                x2="10.34"
                y2="21.76"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M9.45,7.81V3.15a2.65,2.65,0,0,0-5.3,0v9.76c0,2.69,2.65,4.9,6.1,5.25.32,0,.64.06,1,.06s.65,0,1-.06c4.34-.27,8-2.34,9.64-5.25a9.2,9.2,0,0,0-2.62-2.86"
              />
            </g>
          </g>
        </svg>
      );
    case 'hirsch':
    case 'wild':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 23.68 32.43"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M6.81.5a10.6,10.6,0,0,0-2,7.89"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M3,7.57A9.07,9.07,0,0,0,8.94,4"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M4.71,6.49A1.63,1.63,0,0,1,3.09,4.86"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M5.16,3.71a1.62,1.62,0,0,1-1-2.06"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M7.39,5.56a1.62,1.62,0,0,1,0-2.3"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M19,23.07H9.8v8.37a.46.46,0,0,1-.46.46h-1a.46.46,0,0,1-.46-.46V23.07c-3.7-3.65-3.55-10.5-3.55-10.5l-2.69-.34-.22,0A.71.71,0,0,1,1,11.86l-.4-.58a.55.55,0,0,1,.15-.73l0,0,0,0L3.29,8.94c1.11-.73,3.18-.89,3.37.49,0,0,1.31,5.45,6.05,5.79h5.7A4.78,4.78,0,0,1,23.18,20V31.47a.47.47,0,0,1-.47.46h-1a.47.47,0,0,1-.46-.46V25.83A8.37,8.37,0,0,1,18,19.37"
              />
            </g>
          </g>
        </svg>
      );
    case 'brokkoli':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 25.09 27"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M17.6,17.22a17.72,17.72,0,0,0-2.74,9.28H10.23A17.27,17.27,0,0,0,6.7,16.15"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M11.34,17.39a8.52,8.52,0,0,1,1.27,3.68,6.49,6.49,0,0,0,.46-3.58"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M2,12.41a3.82,3.82,0,0,0,6.8,2.07,3.85,3.85,0,0,0,6.57,1.82,3.81,3.81,0,0,0,2,.58,3.85,3.85,0,0,0,3.81-3.4A5.2,5.2,0,0,0,23.06,4.9a5.1,5.1,0,0,0-3.17-1.48A3.83,3.83,0,0,0,13.11,2,3.84,3.84,0,0,0,6.28,3.58,5.2,5.2,0,0,0,2,12.41Z"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M17.24,8.91a2.41,2.41,0,0,0-.92-2.81,2.43,2.43,0,0,0-2.12-.27"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M10.2,9.05a2.4,2.4,0,0,0-4,1.62"
              />
            </g>
          </g>
        </svg>
      );
    case 'kürbis':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 29.35 25.1"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M17.56,7.07C33.3,1.13,30.43,27.19,21.94,22.79c-1.52,2.27-5.46,2.27-7.28.76-1.21,1.36-5.28,1.12-5.92,0C-2.18,26.88-3.62.11,12.84,7.16"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M12.79,8.69c.16.66,5.3.23,5.26-.21C18,7.52,17.5,6.94,16.94,7c-.27-3,1-3.54,2.06-4.58C18.45.77,17.9.5,16.26.5c-1.09,1.37-1.76,4.31-1.89,6.37C13.61,6.51,12.52,7.6,12.79,8.69Z"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M12.79,8.69c-2.15-.39-4,1.2-4,2"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M21.18,10c-.3-1.06-1.67-1.36-3.13-1.49"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M15.11,9.14a7.21,7.21,0,0,0-.45,2.35"
              />
            </g>
          </g>
        </svg>
      );
    case 'banane':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 23.62 26.54"
        >
          <defs></defs>
          <g>
            <g>
              <polyline
                fill="none"
                stroke="currentColor"
                points="6.47 5.43 9.31 1.91 6.13 0.5 5.01 4.79"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M4.37,22.4A11.81,11.81,0,0,1,3.61,5.67,2,2,0,0,1,5,4.88a1.84,1.84,0,0,1,1.37.48A1.64,1.64,0,0,1,6.82,6.9a11.89,11.89,0,0,0,3.83,9.62h0A13.71,13.71,0,0,0,21,20.13a2,2,0,0,1,1.65.43,1.57,1.57,0,0,1,.51,1.28,1.8,1.8,0,0,1-.85,1.29A13.9,13.9,0,0,1,4.4,22.42h0Z"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M4.82,11.67c.86,3.66,3.41,8.6,10.79,10"
              />
            </g>
          </g>
        </svg>
      );
    case 'apfel':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 24.41 27.87"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M12.16,25.86c1.05,0,1.76,1.32,3.11,1.45,1.7.17,3.86-.86,6.27-4.22,5.15-7.19,1.85-19.32-9.38-14.33C1.39,2.9-2.37,15.9,2.79,23.09c2.4,3.36,4.72,4.59,6.26,4.22C10.43,27,11.11,25.86,12.16,25.86Z"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M5.58,12.6c-1.64,1.5-1.77,4.89-.15,7.13"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M10.62.5a23,23,0,0,1,1.54,8.26"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M12,5.72c1.13-4.28,4.09-5.72,6.79-5C18.54,3.77,16,5.53,12,5.72Z"
              />
            </g>
          </g>
        </svg>
      );
    case 'süßkartoffel':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-12 w-auto"
          viewBox="0 0 26.51 21.53"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M1.28,20.58c5-5.71,4.38-8.71,9.37-11.13C16.1,6.81,16,4.21,19.07,3S23.87-.34,26,.84C24.59,4.17,22.45,5.36,22.92,8s-.7,2.64-1.18,6-5.12,5.92-7.88,5.92a38.64,38.64,0,0,0-9.25.72C1.76,21.05-.86,21.29,1.28,20.58Z"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M9.27,10.83c2,1.07,1.69,1.07,2.14,2.6"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M13.25,19.71A2.6,2.6,0,0,0,14.17,18"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M15.7,9.45c1.53,1.07,2.76,2.91,2.45,4.13"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M17.85,4.09c.72.25,1.37.15,1.68,1.38"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M6.52,19.86a1.93,1.93,0,0,0-.31-2.6"
              />
            </g>
          </g>
        </svg>
      );
    case 'reis':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 22.26 25.39"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="none"
                stroke="currentColor"
                d="M2.65,3.83c-1-.18-2.66,2.78-2,3.6s6.09-.17,9.68-.17a76.73,76.73,0,0,1,9.48.49c2.29.33,1.48-3.27-.49-3.43s-6.86-.16-9.48-.16A60.8,60.8,0,0,1,2.65,3.83Z"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M2,7.73c-.65,1.8-1.35,10.14.33,13.88.53,1.18-2.52,2.85-1,2.8.8,0,1.45-.43,3.24-.59S8.7,24.88,12,24.88a24.86,24.86,0,0,0,6.45-.42c.64-.13,1.87.69,3,.1s-1-1.56-.71-3.19,1.21-11.68-.92-13.48"
              />
              <path
                fill="none"
                stroke="currentColor"
                d="M3.68,3.89c-.65-.75-.05-1.46,1-1.72A1.12,1.12,0,0,1,6.43,1.5C6.45.88,8.07.19,8.76.7c1-.26,1.56-.26,2,.18a2,2,0,0,1,2.5.1c.21-.63,2.34-.71,2.34.64.49-.31,1.46-.29,1.46.4.6-.43,1.3.34,1.3.77.86.09,1.43,1.24,1,1.53"
              />
            </g>
          </g>
        </svg>
      );
    case 'fenchel':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-auto w-10"
          viewBox="0 0 52 70.09"
        >
          <defs></defs>
          <g>
            <g>
              <path
                fill="currentColor"
                stroke="none"
                d="M26,64.44c-8,0-14.77-4-18-10.82l2.05-1c2.82,6,8.78,9.53,15.93,9.53Z"
              />
              <path
                fill="currentColor"
                stroke="none"
                d="M26,70.09c-13.85,0-26-12.15-26-26a23.53,23.53,0,0,1,5.61-15L3.4,6.91a2.07,2.07,0,0,1,2-2.36L8.92,3.41A2.09,2.09,0,0,1,11.3,5.54l2,17.31c.43-.31.87-.61,1.29-.86L12.44,2.4A2,2,0,0,1,13.08.64,2.5,2.5,0,0,1,14.59,0h3.5a2,2,0,0,1,1.63.64,2.59,2.59,0,0,1,.62,1.52l2.07,17.57A11.24,11.24,0,0,1,26,19.23a11.24,11.24,0,0,1,3.59.51l2.07-17.6A2.4,2.4,0,0,1,32.48.47,2,2,0,0,1,34,0H37.3a2.61,2.61,0,0,1,1.62.63,2,2,0,0,1,.64,1.74L37.38,22c.41.26.85.56,1.28.86l2-17.33c.27-2.2,1.89-2.18,2.39-2.12l.22,0,3.29,1.1a2,2,0,0,1,2,2.37L46.39,29.07C50.11,34,52,39,52,44.09,52,57.94,39.85,70.09,26,70.09ZM5.66,6.8,8,29.75l-.29.37c-3.63,4.42-5.4,9-5.4,14C2.26,56.74,13.35,67.83,26,67.83S49.74,56.74,49.74,44.09c0-4.66-1.82-9.37-5.42-14l-.27-.35L46.34,6.8h-.13L46,6.73l-3-1s0,0,0,.08L40.47,26.85l-1.53-1L38,25.16a22.19,22.19,0,0,0-2.32-1.53L35,23.28l2.34-21H33.92s0,.07,0,.11L31.37,23.94l-1.65-1.65h0s-1-.8-3.72-.8-3.74.82-3.75.82l-1.61,1.4-.28-2.09L18.09,2.4s0-.09,0-.13H14.7l2.34,21-.75.34a13.37,13.37,0,0,0-2,1.33c-.44.32-.86.62-1.22.85l-1.52,1L9.05,5.8a.22.22,0,0,0,0-.08L5.77,6.79ZM33.74,1.14l0,1.13.11,0Z"
              />
              <path
                fill="currentColor"
                stroke="none"
                d="M38.39,65.88l-2.17-.62c2.07-7.26-2.14-14.73-10.73-19C17.27,42.13,11.3,33.14,11.3,24.88h2.27c0,7.45,5.44,15.59,12.94,19.33C36.11,49,40.78,57.52,38.39,65.88Z"
              />
              <path
                fill="currentColor"
                stroke="none"
                d="M22.61,44.09V41.83c9.06,0,15.82-8.95,15.82-16.95H40.7C40.7,35.11,32.24,44.09,22.61,44.09Z"
              />
              <path
                fill="currentColor"
                stroke="none"
                d="M43.76,56.2l-1.6-1.6C45.75,51,47.81,44.35,45,37.16A16.78,16.78,0,0,1,44,42.34l-2-1c.73-1.47,1-6,1-8.54a1.13,1.13,0,0,1,2.09-.6C51.05,41.8,48.59,51.37,43.76,56.2Z"
              />
              <path
                fill="currentColor"
                stroke="none"
                d="M36.17,36.18c-8.72,0-15.82-6.59-15.82-14.69h2.26c0,6.85,6.08,12.43,13.56,12.43Z"
              />
              <path
                fill="currentColor"
                stroke="none"
                d="M23.74,29.4V27.14a5.8,5.8,0,0,0,5.65-5.65h2.26A8,8,0,0,1,23.74,29.4Z"
              />
              <path
                fill="currentColor"
                stroke="none"
                d="M31,32.67l-1-2c1.75-.88,3.76-3.71,2.82-6.54L35,23.39A8,8,0,0,1,31,32.67Z"
              />
            </g>
          </g>
        </svg>
      );
    case 'wasserbüffel':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-10 w-auto"
          viewBox="0 0 36.6038 24.4349"
        >
          <path
            fill="none"
            stroke="currentColor"
            d="M8.2843,9.6362l4.6879,6.4618v7.3053a.5316.5316,0,0,0,.5317.5316h1.45a.5149.5149,0,0,0,.5222-.5213V17.6648l1.052-1.5668H27.2925"
          />
          <path
            fill="none"
            stroke="currentColor"
            d="M23.9165,10.0525a7.1081,7.1081,0,0,0,7.108,7.108v6.2428a.5316.5316,0,0,0,.5317.5316h1.1561a.5317.5317,0,0,0,.5317-.5316V7.2989A4.1841,4.1841,0,0,0,29.06,3.1148l-17.7756.5214"
          />
          <path
            fill="none"
            stroke="currentColor"
            d="M36.1038,11.8947a1.0157,1.0157,0,0,1-1.0157-1.0157V6.0038a1.6029,1.6029,0,0,0-1.6029-1.6029H32.0766"
          />
          <path
            fill="none"
            stroke="currentColor"
            d="M4.7508,3.95l2.5109.9628c1.7455.6507,3.3889-.1773,3.4438-1.8047L10.5247.9494,9.2843.5V3.1076c-.0818.4045-.7336.3827-.8653.0769A1.4744,1.4744,0,0,0,6.9156,2.1284,2.2429,2.2429,0,0,0,4.7508,3.95L4.16,5.4877,1.7154,7.7134.6847,8.3662.5,9.2245l.6458,1.2632.1879.1233a1.7839,1.7839,0,0,0,.9789.2926h0a1.7857,1.7857,0,0,0,.6529-.1237l.4378-.1437h.7661a4.5344,4.5344,0,0,0,.9735.1339,5.5189,5.5189,0,0,0,2.6813-.8073h0L9.0948,8.9312"
          />
        </svg>
      );
    case 'wildschwein':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-10 w-auto"
          viewBox="0 0 43.13 27"
        >
          <g>
            <path
              fill="currentColor"
              stroke="currentColor"
              d="M2 15a.21.21 0 0 0 .12 0h.07a13 13 0 0 1 3.6-.77 6.48 6.48 0 0 1 1.21.31 10.49 10.49 0 0 0 2.93.46 5.17 5.17 0 0 0 2.21-.35c.28.42 1 1.65 1.27 2.07a4.26 4.26 0 0 1 .45 2.95l-.19.86a5.57 5.57 0 0 1-.64 2c-.2.32-.46.67-.72 1a5.77 5.77 0 0 0-.74 1.13.19.19 0 0 0 .19.27H15a.2.2 0 0 0 .2-.16v-.06A21.39 21.39 0 0 1 16.64 20c.52-1.14 1-1.93 1.18-2.32a4.66 4.66 0 0 1 .68 2.14v.75a5.18 5.18 0 0 1-.14 2.05 5.5 5.5 0 0 1-.52 1 2.21 2.21 0 0 0-.45 1 .2.2 0 0 0 .2.2h3.26a.2.2 0 0 0 .14-.06.22.22 0 0 0 .06-.15 16.07 16.07 0 0 1 .27-4.46 16.35 16.35 0 0 1 .6-2.15 8.25 8.25 0 0 0 .35-1.33 3.51 3.51 0 0 0 0-1.17H24.07c1.61 0 3.86-.08 5.78-.19.17 1.91.61 2.82 1.55 3.2l.26.1a2.36 2.36 0 0 1 1.56 1.22c.36.78-1.25 4.25-1.67 4.64a.2.2 0 0 0 .14.35h2.91a.18.18 0 0 0 .14-.06.2.2 0 0 0 .06-.14 21.69 21.69 0 0 1 1-3.17c.34-1 .69-2 .93-2.77a3.45 3.45 0 0 1 1.3 1c.65.8-.42 4.43-.63 4.85a.2.2 0 0 0 0 .2.2.2 0 0 0 .17.09h2.82a.2.2 0 0 0 .17-.09.21.21 0 0 0 0-.19 16.1 16.1 0 0 1 .18-3.44c.24-2.27.37-3.79.14-4.29a2.92 2.92 0 0 0-.88-1.04 4.77 4.77 0 0 1-.8-.88c-.34-.5-.09-1.34.21-2.31a11.71 11.71 0 0 0 .51-2.19C40 8 40 6.11 38.87 4.81a15.21 15.21 0 0 0-5.72-3.35 16 16 0 0 0-3.88-.37c-.75 0-1.46 0-2-.09S26.1.84 25.35.72A39.11 39.11 0 0 0 20 .12 76.58 76.58 0 0 0 9.91 1.53a1.32 1.32 0 0 0-.12-.22.2.2 0 0 0-.25-.09A4.78 4.78 0 0 0 8.3 2 4.27 4.27 0 0 0 6 3.73a2.53 2.53 0 0 0-.2 1.13 3.36 3.36 0 0 1-.2 1.35c-.4 1-2.8 4.35-3.88 5a12.91 12.91 0 0 0-1.57 2.22.2.2 0 0 0 .06.27zm14.31 4.84a21.26 21.26 0 0 0-1.42 4.58H12.1c.13-.22.34-.49.54-.76l.73-1a5.84 5.84 0 0 0 .7-2.09c0-.25.11-.53.18-.85a4.68 4.68 0 0 0-.48-3.23c-.22-.43-1-1.61-1.27-2.07l.21-.14c.18 0 .69.11 2.17.31.4.42.87.86 1.31 1.28a11.38 11.38 0 0 1 1.05 1l.32.45a27.13 27.13 0 0 0-1.29 2.55zm19.09 1.51a25.69 25.69 0 0 0-1 3.1h-2.33c.66-1.05 1.91-3.89 1.49-4.77a2.71 2.71 0 0 0-1.77-1.41l-.26-.11c-.65-.26-1.11-.85-1.3-2.84 1.18-.08 2.19-.16 2.79-.25.54 1.21 1.69 2.9 2.66 3.24l.16.06.5.18c-.25.81-.6 1.82-.94 2.8zM1.93 11.56c1.19-.71 3.61-4.13 4-5.19a3.68 3.68 0 0 0 .24-1.52 2.07 2.07 0 0 1 .13-.95 3.16 3.16 0 0 1 1.46-1.21 1.28 1.28 0 0 0-.13.67A3 3 0 0 0 8.7 5.52h.11a.2.2 0 0 0 .12-.37A2.5 2.5 0 0 1 8 3.33c0-.73 1-1.39 1.53-1.66a11.69 11.69 0 0 1 1.36 3.6.2.2 0 1 0 .4 0 10.66 10.66 0 0 0-1.18-3.37A76 76 0 0 1 20 .53a38.73 38.73 0 0 1 5.29.59c.75.12 1.4.22 1.9.28s1.32.08 2.08.1a15.92 15.92 0 0 1 3.73.35 14.7 14.7 0 0 1 5.54 3.23c1.06 1.18 1.06 3 1 5.28a10.56 10.56 0 0 1-.49 2.1c-.32 1.07-.61 2-.15 2.66a4.62 4.62 0 0 0 .86 1 2.72 2.72 0 0 1 .76.94 16 16 0 0 1-.17 4.07 20.79 20.79 0 0 0-.21 3.37h-2.28c.36-1 1.2-4.09.46-5A4.54 4.54 0 0 0 36 18l-.16-.06c-.8-.28-2-1.94-2.51-3.23A3.79 3.79 0 0 0 32 12.87a.21.21 0 0 0-.28.07.22.22 0 0 0 .07.28 3.38 3.38 0 0 1 1.11 1.46 80.74 80.74 0 0 1-10.4.39h-.3c0-.19-.1-.4-.17-.61-.12-.4-.25-.86-.36-1.41a.2.2 0 1 0-.4.08c.12.57.25 1 .37 1.44a4.32 4.32 0 0 1 .28 2 7.23 7.23 0 0 1-.33 1.26A16.85 16.85 0 0 0 21 20.1a16.62 16.62 0 0 0-.29 4.35h-2.83a4.62 4.62 0 0 1 .33-.59 6.32 6.32 0 0 0 .57-1.06 5.65 5.65 0 0 0 .16-2.21v-.75a5.2 5.2 0 0 0-.94-2.63 7.03 7.03 0 0 0-1.51-1.67 21.77 21.77 0 0 1-1.8-1.82.2.2 0 0 0-.28 0 .22.22 0 0 0 0 .29l.11.12-1.41-.19a5.08 5.08 0 0 0 .79-2.68.21.21 0 0 0-.2-.21.2.2 0 0 0-.21.19 4.41 4.41 0 0 1-.86 2.67l-.12.07a3.8 3.8 0 0 1-2.53.61 10.32 10.32 0 0 1-2.82-.4 6.49 6.49 0 0 0-1.34-.26 12.26 12.26 0 0 0-3.66.75L.6 13.49a12.32 12.32 0 0 1 1.33-1.93z"
            />
          </g>
        </svg>
      );
    default:
      return <div />;
  }
};

const Ingredients: React.FC<ISectionIngredientsFields> = ({
  title,
  backgroundColor,
  ratioPlate,
  ingradients,
  otherIngredients,
  richTitle,
}) => {
  return (
    <ContentContainer backgroundColor={backgroundColor}>
      <div className="items-center md:flex">
        <div className="md:w-1/2">
          <Image {...ratioPlate} className="mb-4 h-auto w-full md:mb-0" />
        </div>
        <div className="md:w-1/2 md:pl-8">
          {richTitle ? (
            <RibbonText text={richTitle} />
          ) : title ? (
            <Title>{title}</Title>
          ) : null}

          <div className="-mx-4 flex flex-wrap justify-around pb-4 md:-mt-2 md:pb-10 lg:flex-nowrap">
            {ingradients.map((ingredient) => {
              return (
                <div className="md:py-auto px-4 py-4" key={ingredient.sys.id}>
                  <div className="flex">
                    <div className="text-grey-700">
                      {renderIngredientIcon(ingredient.fields.icon)}
                    </div>
                    <div className="pl-2 text-5xl leading-none">
                      {ingredient.fields.percentage}%
                    </div>
                  </div>
                  <div
                    className="pt-2 text-center text-sm leading-snug"
                    style={{ maxWidth: '10rem' }}
                  >
                    {ingredient.fields.label}
                  </div>
                </div>
              );
            })}
          </div>

          {otherIngredients && (
            <div className="text-center text-sm">
              {renderDocument(otherIngredients)}
            </div>
          )}
        </div>
      </div>
    </ContentContainer>
  );
};

export default Ingredients;
